import React from "react";
import PageHelmet from "../component/common/Helmet";
import ContactForm from "./contact/ContactForm";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import Breadcrumb from "./common/Breadcrumb";


const Contact = () => {
    return (
        <React.Fragment>
            <PageHelmet pageTitle='Contact'/>

            <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png"/>

            <Breadcrumb title={'Contact Us'}/>






            <div className="rn-contact-page ptb--120 bg_color--1">
                <ContactForm/>
            </div>



            <Footer/>

        </React.Fragment>
    )
};

Contact.defaultProps = {
    center: {
        lat: 59.95,
        lng: 30.33
    },
    zoom: 11
};

export default Contact
